/** Next UTC run for weekly EPG schedule (weekday 0=Sun … 6=Sat, timeOfDay "HH:MM"). */
export function computeNextRunAt(weekday: number, timeOfDay: string): string | null {
  const [h, m] = timeOfDay.split(':').map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return null
  const now = new Date()
  const d = new Date(now)
  d.setUTCHours(h, m, 0, 0)
  let daysToAdd = (weekday - now.getUTCDay() + 7) % 7
  if (daysToAdd === 0 && d <= now) daysToAdd = 7
  d.setUTCDate(now.getUTCDate() + daysToAdd)
  if (d <= now) d.setUTCDate(d.getUTCDate() + 7)
  return d.toISOString()
}

export const FREEVIEW_EPG_FEED_NAME = 'freeview-epg'
